import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Smelt silhouette uses the ★1 tier art. The active rendering
// for Stream Smelt goes through TIERED_GLYPHS (see tieredGlyphs.ts)
// which routes ★2/★3 to the richer tier images extracted from
// assets/stream_smelt_3tier.jpg.
export const Smelt = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/smelt-1.png" size={size} alt="smelt" />
)
